import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CompanyService }      from '../companies/company.service';
import { CustomerModel }      from '../customers/models/customer';
import { SelectOption }        from '../core/models/select-option';
import { SessionCompanyModel } from '../sessions/models/session.company';
import { SessionService }      from '../sessions/session.service';
import { VehicleModel }        from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-form-music',
  template: require('./vehicle.form-music.component.html')
})
export class VehicleFormMusicComponent {
  @Input() vehicle: VehicleModel;
  @Input() company: SessionCompanyModel;
  @Input() customer: CustomerModel;
  @Input() body_types_limited: SelectOption[];
  @Input() plateDuplicate: boolean;

  @Output() onCheckPlate = new EventEmitter<void>();
  @Output() onDelete     = new EventEmitter<void>();
  @Output() onArchive    = new EventEmitter<void>();

  constructor(
    public companyService: CompanyService,
    public sessionService: SessionService
  ) {}

  canUnarchiveVehicle (): boolean {


    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;


  }
}
